import { render, staticRenderFns } from "./TagDetails.vue?vue&type=template&id=e76ef6f2&scoped=true&"
import script from "./TagDetails.vue?vue&type=script&lang=js&"
export * from "./TagDetails.vue?vue&type=script&lang=js&"
import style0 from "./TagDetails.vue?vue&type=style&index=0&id=e76ef6f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76ef6f2",
  null
  
)

export default component.exports